import React from 'react';

const TABS_OPERACIONAIS = [
    { id: 'DESENVOLVIMENTO', label: 'Desenvolvimento', icon: 'fa-code-branch' },
    { id: 'HORAS', label: 'Lançamento de horas', icon: 'fa-clock' },
];

const TABS_CONTEUDO = [
    { id: 'ATENDIMENTO', label: 'Atendimento' },
    { id: 'ANALISE', label: 'Análise de requisitos' },
    { id: 'TESTE', label: 'Considerações de teste' },
];

function ChamadoTabs({ abaAtiva, onAbaChange }) {
    const renderBtn = (tab, extraClass) => (
        <button
            key={tab.id}
            type="button"
            role="tab"
            className={`chamado-tab-btn ${extraClass || ''} ${abaAtiva === tab.id ? 'active' : ''}`}
            aria-selected={abaAtiva === tab.id}
            onClick={() => onAbaChange(tab.id)}
        >
            {tab.icon ? <i className={`fas ${tab.icon} me-1`} aria-hidden="true" /> : null}
            {tab.label}
        </button>
    );

    return (
        <div className="chamado-tabs-bar">
            <div className="chamado-tabs chamado-tabs--conteudo" role="tablist" aria-label="Conteúdo do chamado">
                {TABS_CONTEUDO.map((tab) => renderBtn(tab))}
            </div>
            <div className="chamado-tabs-divider" aria-hidden="true" />
            <div className="chamado-tabs chamado-tabs--operacional" role="tablist" aria-label="Operacional">
                {TABS_OPERACIONAIS.map((tab) => renderBtn(tab, 'chamado-tab-btn--operacional'))}
            </div>
        </div>
    );
}

export default ChamadoTabs;
